import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🛒", key: "beforeBuying" },
  { emoji: "🧰", key: "beforeService" },
  { emoji: "💸", key: "beforeSelling" },
  { emoji: "📅", key: "dailyManagement" },
]

export default function CarsDecisionMomentPage() {
  return (
    <RadioCardListPage translationKey="carsDecisionMoment" options={OPTIONS} />
  )
}
